export default "__VITE_ASSET__b01185ad__"